import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';
import Sidebar from "../componenteExtra/SidebarsocioGET";
import Modal from 'react-modal';
import { Toaster, toast } from 'react-hot-toast';
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement('#root');

const ActividadGET = () => {
  const [activities, setActivities] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedProcedimiento, setSelectedProcedimiento] = useState('');
  const [newActivityModalIsOpen, setNewActivityModalIsOpen] = useState(false);
  
  // Estados para eliminación
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [activityToDelete, setActivityToDelete] = useState(null);

  // Estados para edición/creación
  const [isEditing, setIsEditing] = useState(false);
  const [currentActivityId, setCurrentActivityId] = useState(null);

  const [newActivityData, setNewActivityData] = useState({
    numero_grupo: '',
    rubro_get: '',
    nombre_actividad_get: '',
    codigo_actividad_get: '',
    procedimiento: '',
    jefe_grupo: '',
    subrogante: ''
  });

  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("access_token");

  // Fetch inicial
  const fetchActivities = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/activities`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setActivities(res.data))
      .catch((err) => toast.error('Error al cargar actividades'));
  };

  useEffect(() => {
    fetchActivities();
  }, [token]);

  // Cargar usuarios para los selects
  useEffect(() => {
    if (!newActivityModalIsOpen) return;
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/get_all_lideres`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data || [];
        const nombresSet = new Set();
        data.forEach((row) => {
          if (row.nombre_lider) nombresSet.add(row.nombre_lider.trim());
          if (row.nombre_subrogante) nombresSet.add(row.nombre_subrogante.trim());
        });
        const usuariosUnicos = Array.from(nombresSet).sort().map(n => ({ id: n, nombre: n }));
        setUsuarios(usuariosUnicos);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [newActivityModalIsOpen, token]);

  // Handlers para el modal de Ver Procedimiento
  const openModal = (procedimiento) => {
    setSelectedProcedimiento(procedimiento);
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedProcedimiento('');
  };

  // Handlers para Crear/Editar
  const openNewActivityModal = (activity = null) => {
    if (activity) {
      setIsEditing(true);
      setCurrentActivityId(activity.id);
      setNewActivityData({ ...activity });
    } else {
      setIsEditing(false);
      setNewActivityData({
        numero_grupo: '', rubro_get: '', nombre_actividad_get: '',
        codigo_actividad_get: '', procedimiento: '', jefe_grupo: '', subrogante: ''
      });
    }
    setNewActivityModalIsOpen(true);
  };

  const closeNewActivityModal = () => {
    setNewActivityModalIsOpen(false);
    setIsEditing(false);
  };

  const handleNewActivityChange = (e) => {
    const { name, value } = e.target;
    setNewActivityData((prev) => ({ ...prev, [name]: value }));
  };

  // Guardar (POST o PUT)
  const handleSaveActivity = () => {
    const required = ['numero_grupo', 'rubro_get', 'nombre_actividad_get', 'codigo_actividad_get', 'procedimiento', 'jefe_grupo'];
    if (required.find((f) => !newActivityData[f])) {
      toast.error('Complete todos los campos obligatorios');
      return;
    }

    const toastId = toast.loading(isEditing ? 'Actualizando...' : 'Añadiendo...');
    const url = isEditing 
      ? `${process.env.REACT_APP_BACKEND_URL}/update_activity/${currentActivityId}` 
      : `${process.env.REACT_APP_BACKEND_URL}/add_new_activity`;
    
    const method = isEditing ? 'put' : 'post';

    axios[method](url, newActivityData, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        toast.dismiss(toastId);
        toast.success(isEditing ? 'Actividad actualizada' : 'Actividad añadida');
        fetchActivities();
        closeNewActivityModal();
      })
      .catch(() => {
        toast.dismiss(toastId);
        toast.error('Error al procesar la solicitud');
      });
  };

  // Lógica de Eliminación con Modal
  const openDeleteModal = (activity) => {
    setActivityToDelete(activity);
    setDeleteModalIsOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setActivityToDelete(null);
  };

  const confirmDelete = () => {
    if (!activityToDelete) return;
    
    const toastId = toast.loading('Eliminando...');
    axios.delete(`${process.env.REACT_APP_BACKEND_URL}/delete_activity/${activityToDelete.id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(() => {
      toast.dismiss(toastId);
      toast.success('Actividad eliminada con éxito');
      setActivities(activities.filter(a => a.id !== activityToDelete.id));
      closeDeleteModal();
    })
    .catch(() => {
      toast.dismiss(toastId);
      toast.error('Error al eliminar la actividad');
      closeDeleteModal();
    });
  };

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Actividades GET</h1>
          <button onClick={() => openNewActivityModal()} className="add-activity-button">
            + Añadir Nueva Actividad
          </button>

          <table className="activities-table">
            <thead>
              <tr>
                <th>Grupo</th>
                <th>Rubro</th>
                <th>Nombre Actividad</th>
                <th>Código</th>
                <th>Procedimiento</th>
                <th>Jefe</th>
                <th>Subrogante</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {activities.map((activity) => (
                <tr key={activity.id}>
                  <td>{activity.numero_grupo}</td>
                  <td>{activity.rubro_get}</td>
                  <td>{activity.nombre_actividad_get}</td>
                  <td>{activity.codigo_actividad_get}</td>
                  <td>
                    <button onClick={() => openModal(activity.procedimiento)} className="view-button">Ver</button>
                  </td>
                  <td>{activity.jefe_grupo}</td>
                  <td>{activity.subrogante}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <button 
                        onClick={() => openNewActivityModal(activity)} 
                        className="edit-button"
                        style={{ backgroundColor: '#ff9800', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}
                      >
                        Editar
                      </button>
                      <button 
                        onClick={() => openDeleteModal(activity)} 
                        className="delete-button"
                        style={{ backgroundColor: '#f44336', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}
                      >
                        Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Modal Ver Procedimiento */}
          <Modal isOpen={modalIsOpen} onRequestClose={closeModal} className="modal-content" overlayClassName="modal-overlay">
            <h2>Procedimiento</h2>
            <p style={{ whiteSpace: 'pre-wrap' }}>{selectedProcedimiento}</p>
            <button onClick={closeModal} className="close-button">Cerrar</button>
          </Modal>

          {/* Modal Añadir/Editar */}
          <Modal
            isOpen={newActivityModalIsOpen}
            onRequestClose={closeNewActivityModal}
            className="modal-content"
            overlayClassName="modal-overlay"
          >
            <h2>{isEditing ? 'Editar Actividad' : 'Añadir Nueva Actividad'}</h2>
            <form className="modal-form">
              <div className="form-group">
                <label>Número de Grupo *</label>
                <input type="text" name="numero_grupo" value={newActivityData.numero_grupo} onChange={handleNewActivityChange} />
              </div>
              <div className="form-group">
                <label>Rubro GET *</label>
                <input type="text" name="rubro_get" value={newActivityData.rubro_get} onChange={handleNewActivityChange} />
              </div>
              <div className="form-group">
                <label>Nombre Actividad *</label>
                <input type="text" name="nombre_actividad_get" value={newActivityData.nombre_actividad_get} onChange={handleNewActivityChange} />
              </div>
              <div className="form-group">
                <label>Código Actividad *</label>
                <input type="text" name="codigo_actividad_get" value={newActivityData.codigo_actividad_get} onChange={handleNewActivityChange} />
              </div>
              <div className="form-group">
                <label>Procedimiento *</label>
                <textarea name="procedimiento" value={newActivityData.procedimiento} onChange={handleNewActivityChange} rows="4" style={{ width: '100%', padding: '8px' }} />
              </div>
              <div className="form-group">
                <label>Líder *</label>
                <select name="jefe_grupo" value={newActivityData.jefe_grupo} onChange={handleNewActivityChange} disabled={loading}>
                  <option value="">Seleccionar</option>
                  {usuarios.map((u) => <option key={u.id} value={u.nombre}>{u.nombre}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Subrogante</label>
                <select name="subrogante" value={newActivityData.subrogante} onChange={handleNewActivityChange} disabled={loading}>
                  <option value="">Seleccionar</option>
                  {usuarios.map((u) => <option key={u.id} value={u.nombre}>{u.nombre}</option>)}
                </select>
              </div>
              <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button type="button" onClick={handleSaveActivity} className="submit-button">
                  {isEditing ? 'Guardar Cambios' : 'Añadir Actividad'}
                </button>
                <button type="button" onClick={closeNewActivityModal} className="close-button" style={{ backgroundColor: '#757575' }}>
                  Cancelar
                </button>
              </div>
            </form>
          </Modal>

          {/* --- NUEVO MODAL DE CONFIRMACIÓN DE ELIMINACIÓN --- */}
          <Modal
            isOpen={deleteModalIsOpen}
            onRequestClose={closeDeleteModal}
            className="modal-content"
            overlayClassName="modal-overlay"
            style={{
              content: {
                maxWidth: '400px',
                margin: 'auto',
                height: 'fit-content',
                textAlign: 'center'
              }
            }}
          >
            <h2 style={{ color: '#d32f2f' }}>¿Confirmar eliminación?</h2>
            <p>
              Estás a punto de eliminar la actividad: <br />
              <strong>{activityToDelete?.nombre_actividad_get}</strong>
            </p>
            <p style={{ fontSize: '0.9rem', color: '#666' }}>Esta acción no se puede deshacer.</p>
            
            <div style={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button 
                onClick={confirmDelete} 
                style={{ backgroundColor: '#f44336', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
              >
                Sí, Eliminar
              </button>
              <button 
                onClick={closeDeleteModal} 
                style={{ backgroundColor: '#757575', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer' }}
              >
                Cancelar
              </button>
            </div>
          </Modal>

        </div>
      </div>
      <Toaster position="top-right" />
    </div>
  );
};

export default ActividadGET;